import { httpRequest } from "@services/http";

export class CommandSendNotification {
  async run(type: string, body: any) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/notifications/`;

    await httpRequest(url, {
      method: "POST",
      body: {type: type, ...body}
    });
  }
}
